import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

// Initialize Sentry with error tracking and performance monitoring
const initSentry = () => {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  const environment = process.env.NODE_ENV || 'development';
  
  // Only initialize Sentry if DSN is provided AND in production
  if (dsn && environment === 'production') {
    Sentry.init({
      dsn,
      environment,
      integrations: [
        new BrowserTracing({
          // Set tracing origins to match your backend
          tracingOrigins: ["localhost", "blackmount.ai", /^\//],
        }),
      ],
      
      // Performance Monitoring
      tracesSampleRate: environment === 'production' ? 0.1 : 1.0, // 10% in prod, 100% in dev
      
      // Release tracking
      release: process.env.REACT_APP_VERSION || 'unknown',
      
      // Capture unhandled promise rejections
      captureUnhandledRejections: true,
      
      // Filter out sensitive data and noisy errors
      beforeSend(event, hint) {
        // Filter out sensitive data
        if (event.user) {
          delete event.user.email;
          delete event.user.username;
        }
        
        // Filter out known noisy errors
        const error = event.exception?.values?.[0];
        if (error?.value?.includes('ResizeObserver loop limit exceeded')) {
          return null; // Don't send ResizeObserver errors
        }
        if (error?.value?.includes('Non-Error promise rejection')) {
          return null; // Don't send non-error rejections
        }
        
        return event;
      }
    });
    
    console.log('[Sentry] Initialized for environment:', environment);
  } else {
    console.log('[Sentry] Skipping initialization - requires DSN and production environment');
  }
};

// Error boundary wrapper
export const SentryErrorBoundary = Sentry.withErrorBoundary;

// Performance profiler
export const SentryProfiler = Sentry.withProfiler;

export default initSentry;